import type { CustomMenuContentCategory } from '@/services/dto';
import type { ListTypeListItem } from '@/types/list-type';

export type DropdownCategoryItem = {
    id: string;
    question: string;
    answer: string;
};

export type DropdownCategorySection = {
    id: string;
    title: string;
    items: DropdownCategoryItem[];
};

export const buildCustomMenuDropdownSections = (
    categories: CustomMenuContentCategory[] | undefined,
    customContent: ListTypeListItem[] | undefined
): DropdownCategorySection[] => {
    if (!categories?.length || !customContent?.length) {
        return [];
    }

    return categories
        .slice()
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
        .map((category) => {
            const items = customContent
                .filter((item) => String(item.categoryId) === String(category.id))
                .sort((a, b) => (b.sortOrder ?? 0) - (a.sortOrder ?? 0))
                .map((item) => ({
                    id: item.id,
                    question: item.title,
                    answer: item.contents,
                }));

            return {
                id: category.id,
                title: typeof category.name === 'string' ? category.name : category.name?.ko || '',
                items,
            };
        })
        .filter((section) => section.items.length > 0);
};
